import { render } from "./Suveniri.vue?vue&type=template&id=d2e8c474&scoped=true"
import script from "./Suveniri.vue?vue&type=script&lang=js"
export * from "./Suveniri.vue?vue&type=script&lang=js"

import "./Suveniri.vue?vue&type=style&index=0&id=d2e8c474&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d2e8c474"]])

export default __exports__